import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Button } from "@mantine/core";
import { IconX, IconSquare, IconPlus } from "@tabler/icons-react";

export function Enqueue({ reqData, onSuccess, id, disabled, dequeue }) {
  const [loading, setLoading] = useState(false);

  function onClick() {
    setLoading(true);

    axios
      .post(`/bulk-communicators/${id}/toggle-enqueue/`, reqData)
      .then(() => {
        setLoading(false);
        toast.success(dequeue ? "Removed from queue!" : "Enqueued!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <Button
      onClick={onClick}
      loading={loading}
      size="sm"
      color={dequeue ? "red" : "blue"}
      disabled={disabled}
      variant={dequeue ? "filled" : "filled"}
      radius="lg"
      leftSection={dequeue ? <IconX size={16} /> : <IconPlus size={16} />}
    >
      {dequeue ? "Remove from queue" : "Add to queue"}
    </Button>
  );
}

export function Stop({ reqData, onSuccess, id, disabled }) {
  const [loading, setLoading] = useState(false);

  function onClick() {
    setLoading(true);

    axios
      .post(`/bulk-communicators/${id}/stop/`, reqData)
      .then(() => {
        setLoading(false);
        toast.success("Stopped!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <Button
      onClick={onClick}
      loading={loading}
      size="sm"
      color={"red"}
      disabled={disabled}
      radius="lg"
      leftSection={
        <IconSquare
          size={16}
          style={{
            fill: "white",
          }}
        />
      }
    >
      Stop
    </Button>
  );
}
